module.exports = __webpack_public_path__ + "img/culture2.1bb9b6a6.jpg";